import { b as it, R as st, T as mt, C as at, a as nt, u as pt } from "./Chatbot2.js";
import { j as t } from "./jsx-runtime.js";
import { d as s } from "./index2.js";
import { I as p } from "./InputBarTrigger2.js";
import { u as lt } from "./InputBarTrigger2.js";
import { MongoDbLegalDisclosure as m } from "./MongoDbLegal.js";
import { MongoDbLegalDisclosureText as xt } from "./MongoDbLegal.js";
import { m as a } from "./ui-text.js";
import { d as dt } from "./ui-text.js";
import { lazy as n, Suspense as g } from "react";
import { FloatingActionButtonTrigger as l } from "./FloatingActionButtonTrigger.js";
import { PoweredByAtlasVectorSearch as f } from "./PoweredByAtlasVectorSearch.js";
import { c as x } from "./Transition.js";
import { useChatbotContext as Mt } from "./useChatbotContext.js";
import { M as bt } from "./InputBar.js";
import { HotkeyTrigger as Tt } from "./HotkeyTrigger.js";
import { ActionButtonTrigger as wt } from "./ActionButtonTrigger.js";
import { f as Dt, g as kt } from "./messageLinks.js";
import { ModalView as It } from "./ModalView.js";
import { ChatWindow as Vt } from "./ChatWindow.js";
import "./index3.js";
import "./ConversationStateProvider2.js";
import "./utils.js";
import "./useConversationStateContext.js";
import "./LinkDataProvider.js";
import "./ChatbotProvider.js";
import "./HotkeyContext.js";
import "./index4.js";
import "./has.js";
import "./useLinkData.js";
import "react-dom";
import "./index5.js";
import "./index6.js";
import "./index7.js";
import "./index8.js";
import "./index9.js";
import "./index10.js";
import "./index11.js";
import "./index12.js";
import "./index13.js";
import "./index14.js";
import "./index15.js";
import "./X.js";
import "./ChevronDown.js";
import "./index16.js";
import "./focus-trap-react.js";
import "./index17.js";
import "./Warning.js";
import "./ChatMessageFeed.js";
const c = n(
  () => import("./ModalView.js").then((o) => ({ default: o.ModalView }))
);
function tt(o) {
  const { darkMode: r } = s(o.darkMode), e = {
    suggestedPrompts: o.suggestedPrompts ?? [],
    bottomContent: /* @__PURE__ */ t.jsx(m, {})
  }, i = {
    darkMode: r,
    inputBottomText: a
  };
  return /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
    /* @__PURE__ */ t.jsx(p, { ...e }),
    /* @__PURE__ */ t.jsx(c, { ...i })
  ] });
}
const d = n(
  () => import("./ModalView.js").then((o) => ({ default: o.ModalView }))
);
function ot(o) {
  const { darkMode: r } = s(o.darkMode), e = {}, i = {
    darkMode: r,
    initialMessageText: o.initialMessageText ?? "Hi! I'm the MongoDB AI. What can I help you with today?",
    initialMessageReferences: o.initialMessageReferences,
    initialMessageSuggestedPrompts: o.initialMessageSuggestedPrompts ?? [],
    disclaimer: /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
      /* @__PURE__ */ t.jsx(m, {}),
      /* @__PURE__ */ t.jsx(
        f,
        {
          className: x`
            margin-top: 8px;
          `,
          linkStyle: "text"
        }
      )
    ] }),
    inputBottomText: a
  };
  return /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
    /* @__PURE__ */ t.jsx(l, { ...e }),
    /* @__PURE__ */ t.jsx(g, { fallback: null, children: /* @__PURE__ */ t.jsx(d, { ...i }) })
  ] });
}
export {
  wt as ActionButtonTrigger,
  Vt as ChatWindow,
  it as ConversationService,
  ot as DevCenterChatbot,
  tt as DocsChatbot,
  l as FloatingActionButtonTrigger,
  Tt as HotkeyTrigger,
  p as InputBarTrigger,
  It as ModalView,
  bt as MongoDbInputBarPlaceholder,
  m as MongoDbLegalDisclosure,
  xt as MongoDbLegalDisclosureText,
  f as PoweredByAtlasVectorSearch,
  st as RetriableError,
  mt as TimeoutError,
  at as default,
  dt as defaultChatbotFatalErrorMessage,
  Dt as formatReferences,
  kt as getMessageLinks,
  a as mongoDbVerifyInformationMessage,
  nt as useChatbot,
  Mt as useChatbotContext,
  pt as useConversation,
  lt as useTextInputTrigger
};
